// import react libraries
import { useState } from "react";

// import common components
import SideBar from "./SideBar";
import AnniversaryBanner from "../components/Common/AnniversaryBanner";

const Layout = ({children, sendTabCheckDataFromChild}) => {
    // get last toggle status
    const local = localStorage.getItem('toggle');
    const locale = localStorage.getItem('locale');
    // variable
    const [isToggle, setIsToggle] = useState(parseInt(local) ? parseInt(local) : 0);

    const handleToggleFromChild = (data) => {
        setIsToggle(data);
    };
    const handleTabChangeDataFromChild = (data) => {
        sendTabCheckDataFromChild(data);
    };

    return (
        <div className="relative">
            <div className="" >
                <SideBar setToggleFromChild={handleToggleFromChild} sendTabChangeDataFromChild={handleTabChangeDataFromChild} />
            </div>
            <div className={(isToggle ? 'sm:ml-16' : (locale === 'gr' ? 'md:ml-60' : 'md:ml-56')) + " bg-background-normal1 h-full min-h-screen"}>
                <div className="sticky top-0 z-50">
                    <AnniversaryBanner />
                </div>
                <div className={(isToggle ? "mt-16" : "") + " sm:mt-0 p-2 sm:p-4 space-y-2 sm:space-y-4"}>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Layout;